'use strict';

const ajax = require('../../modules/ajax'),
    isMobile = require('../../modules/util/isMobile'),
    appendParamsToUrl = require('../../modules/util/appendParamsToUrl'),
    isInViewport = require('../../modules/helpers/isInViewport'),
    isAdvent = document.querySelectorAll('.js-advent-block').length > 0,
    isOnboardingPage = document.querySelectorAll('.js-onboarding-page').length > 0;

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    if (stickyAddToCart.def.$pdpButtonEl.length > 0) {
        $(window).on('scroll', windowScrollHandler);
    }

    // handle click in select size or select option - inside the sticky bar only
    $(document).on('click', '.js-sticky-add-to-cart .js-pdp-select-size-btn, .js-sticky-add-to-cart .js-select-option', function(){
        scrollToOptionsPicker();
    });

    $(document).on('stickyAddToCart.onNotSelectedOption', function(){
        scrollToOptionsPicker();
    });

    if (isAdvent) {
        windowScrollHandler();
    }

    if (isOnboardingPage){
        $(window).on('scroll', windowScrollStickyCtaHandler);
    }
}

/**
 * @description window scroll handler for the sticky add to cart
 **/
function windowScrollHandler() {
    getDefs();
    const scroll = $(window).scrollTop(); // how many pixels you've scrolled
    const pdpAddToCartButtonEl = stickyAddToCart.def.$pdpButtonEl.find(stickyAddToCart.def.pdpBtnClass);
    const pdpAddToCartOffset = stickyAddToCart.def.$pdpButtonEl.offset().top; // pixels to the top of the pdp add to cart btn
    const pdpAddToCartHeight = pdpAddToCartButtonEl.height(); // height of pdp add to cart btn
    const footerIsInView = isInViewport('.js-footer');

    // if you've scrolled further than the top of add to cart btn plus its height
    // show sticky bar.
    // else hide sticky bar
    if (isAdvent) {
        stickyAddToCart.def.$stickyBarEl.toggleClass('show-bar', !isInViewport(pdpAddToCartButtonEl) && !footerIsInView);
    } else if (scroll > pdpAddToCartOffset + pdpAddToCartHeight){
        // if there is a packshot hide sticky if packshot or footer are in viewport
        const $packshotEl = $('.js-packshot-container');

        if ($packshotEl.length > 0) {
            const packshotIsInView = isInViewport($packshotEl);
            if (packshotIsInView || footerIsInView) {
                stickyAddToCart.def.$stickyBarEl.removeClass('show-bar');
            } else {
                stickyAddToCart.def.$stickyBarEl.addClass('show-bar');
            }
            return;
        } else {
            if (footerIsInView) {
                stickyAddToCart.def.$stickyBarEl.removeClass('show-bar');
            } else {
                stickyAddToCart.def.$stickyBarEl.addClass('show-bar');
            }
            return;
        }
    } else {
        stickyAddToCart.def.$stickyBarEl.removeClass('show-bar');
    }
}
function windowScrollStickyCtaHandler(){
    const footerIsInView = isInViewport('.js-footer');
    const heroIsInView = isInViewport('.js-crm-hero');
    const lastNugdeIsInView = isInViewport('.js-last-nudge');
    stickyAddToCart.def.$stickyBarEl.toggleClass('show-bar', !footerIsInView && !heroIsInView && !lastNugdeIsInView);
}
function scrollToOptionsPicker(){
    if (!isMobile()) {
        $('html, body').animate({scrollTop: 0}, 'slow');

        return;
    }

    $('html, body').animate({scrollTop: $('.js-product-details-block').offset().top}, 'slow');
}

/**
 * @description inserts the dropdown in the select size button
 **/
function initVariationsDropdown(){
    $('.js-variations-dropdown').insertAfter('.js-sticky-add-to-cart .js-pdp-select-size-btn');
}

/**
 * @description inserts the dropdown in the select size button
 **/
function initOptionsDropdown(){
    $('.js-sticky-add-to-cart .js-options-dropdown').insertAfter('.js-sticky-add-to-cart .js-select-option');
    $('.js-sticky-add-to-cart .js-options-hidden-input').insertAfter('.js-sticky-add-to-cart .js-select-option');
}

/**
 * @description update add to cart button
 **/
function updateAddToCartBtn(variation, isSelected){
    const $updateTarget = $('.js-sticky-add-to-cart-form');
    const url = Urls.addToCartPartial;

    const $variationElement = $(variation).find('option').length > 0 ? $(variation).find('option:selected') : $(variation);

    const pid = isSelected ? $variationElement.data('masterid') : $variationElement.data('pid');

    const params = {
        pid: pid,
        uuid: ''
    };

    ajax.load({
        url: appendParamsToUrl(url, params),
        target: $updateTarget
    });
}

/**
 * @description refresh values for the cached - useful for ajax'ed elements
 **/
function getDefs(){
    const currentButton =
        $('.js-product-details-content .js-add-to-cart').length > 0
            ? '.js-add-to-cart'
            : $('.js-product-details-content .js-out-of-stock-button').length > 0
                ? '.js-out-of-stock-button'
                : $('.js-product-details-content .js-out-of-stock-btn').length > 0
                    ? '.js-out-of-stock-btn'
                    : false;
    stickyAddToCart.def = {
        $pdpButtonEl: $('.js-pdp-add-to-cart-form'),
        pdpBtnClass: currentButton ? currentButton
            : $('.js-product-details-content .js-product-configurator-trigger').length > 0 ? '.js-product-configurator-trigger' : '.js-select-option',
        $stickyBarEl: $('.js-sticky-add-to-cart'),
        $stickyAddToCartForm: $('.js-sticky-add-to-cart-form')
    };
}

/**
 * @description check if sticky bar exists in the page
 **/
function stickyBarExists(){
    return $('.js-sticky-add-to-cart').length > 0;
}


const stickyAddToCart = {
    init: function() {
        if (stickyBarExists()){
            getDefs();
            initializeEvents();
            initVariationsDropdown();
            initOptionsDropdown();
        }
    },
    updateAddToCartBtn: function(variation, isSelected){
        if (stickyBarExists()){
            updateAddToCartBtn(variation, isSelected);
        }
    }
};

module.exports = stickyAddToCart;
